import { Button, Group, Stack, TextInput, Title, Image } from '@mantine/core';
import { normalizeOperationOutcome } from '@medplum/core';
import { OperationOutcome } from '@medplum/fhirtypes';
import {
  Document,
  Form,
  getErrorsForInput,
  getIssuesForExpression,
  getRecaptcha,
  initRecaptcha,
  OperationOutcomeAlert,
  useMedplum,
} from '@medplum/react';
import logo from '/ainigma-logo-small.png';

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigService } from '../../services/config.service';

export function ResetPasswordPage(): JSX.Element {
  const medplum = useMedplum();
  const [outcome, setOutcome] = useState<OperationOutcome>();
  const [success, setSuccess] = useState(false);
  const { t } = useTranslation(['signin-page']);
  const recaptchaSiteKey = ConfigService.getRecaptchaSiteKey();

  useEffect(() => {
    if (recaptchaSiteKey) {
      initRecaptcha(recaptchaSiteKey);
    }
  }, [recaptchaSiteKey]);

  return (
    <Document width={450}>
      <Form
        onSubmit={async (formData: Record<string, string>) => {
          let recaptchaToken = '';
          if (recaptchaSiteKey) {
            recaptchaToken = await getRecaptcha(recaptchaSiteKey);
          }

          medplum
            .post('auth/resetpassword', {
              ...formData,
              recaptchaToken,
              recaptchaSiteKey,
            })
            .then(() => setSuccess(true))
            .catch((err) => setOutcome(normalizeOperationOutcome(err)));
        }}
      >
        <Stack gap="lg" mb="xl" align="center">
          <Image src={logo} alt="Logo" w={32} h={32} />
          <Title>{t('resetPassword.title', { ns: 'signin-page' })}</Title>
        </Stack>
        <Stack gap="xl">
          <OperationOutcomeAlert
            issues={getIssuesForExpression(outcome, undefined)}
          />
          {!success && (
            <>
              <TextInput
                name="email"
                type="email"
                label={t('resetPassword.emailLabel', { ns: 'signin-page' })}
                required={true}
                autoFocus={true}
                error={getErrorsForInput(outcome, 'email')}
              />
              <Group justify="space-between" mt="xl" wrap="nowrap">
                <Button type="submit">
                  {t('resetPassword.button', { ns: 'signin-page' })}
                </Button>
              </Group>
            </>
          )}
          {success && (
            <div>
              {t('resetPassword.successMessage', { ns: 'signin-page' })}
            </div>
          )}
        </Stack>
      </Form>
    </Document>
  );
}
